import React from 'react';
import * as enums from '@local/finsera-core/src/enums';
import { _ } from '@local/finsera-core/src/libs';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import AssetSelector from '../../../asset-selector';
import NumericField from '../../../numeric-field';

type SharesOutstandingConstraintProps = {
  id: string;
  params: types.optimizer.SharesOutstadingDraft;
  setParams: (_params: types.optimizer.SharesOutstadingDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
  dates: {
    start: string;
    end: string;
  };
};

const SharesOutstandingConstraint = ({
  id,
  params,
  setParams,
  readOnly,
  dates,
  validationDef,
}: SharesOutstandingConstraintProps) => {
  const [allAssets, setAllAssets] = React.useState(_.isEmpty(params.asset_fids));

  return (
    <mui.core.Box p={3}>
      <mui.core.Grid container spacing={4} pb={3}>
        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <NumericField
            textFieldProps={{
              label: 'Shares Outstanding Lower Bound %',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              error: validationDef?.fields?.includes(`lower_shares_outstanding_bound_${id}`),
            }}
            disabled={readOnly}
            suffix="%"
            dividerOption={enums.NUMBER_FORMATTERS_ENUM.HUNDRED}
            value={params.lower_shares_outstanding_bound}
            setValue={(v) =>
              setParams({
                ...params,
                lower_shares_outstanding_bound: v,
              })
            }
          />
        </mui.core.Grid>

        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <NumericField
            textFieldProps={{
              label: 'Shares Outstanding Upper Bound %',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              error: validationDef?.fields?.includes(`upper_shares_outstanding_bound_${id}`),
            }}
            disabled={readOnly}
            suffix="%"
            dividerOption={enums.NUMBER_FORMATTERS_ENUM.HUNDRED}
            value={params.upper_shares_outstanding_bound}
            setValue={(v) =>
              setParams({
                ...params,
                upper_shares_outstanding_bound: v,
              })
            }
          />
        </mui.core.Grid>
        <mui.core.Grid size={{ xs: 12, md: 3 }} >
          <mui.core.FormControlLabel
            style={{
              paddingLeft: '16px',
            }}
            control={
              <mui.core.Switch
                size="small"
                checked={allAssets}
                onChange={() => {
                  setAllAssets(!allAssets);
                  if (!allAssets) {
                    setParams({
                      ...params,
                      asset_fids: [],
                    });
                  }
                }}
                disabled={readOnly}
              />
            }
            label="All Assets"
          />
        </mui.core.Grid>
        {!allAssets && (
          <mui.core.Grid size={{ xs: 12, md: 9 }}>
            <AssetSelector
              value={params.asset_fids as string[]}
              setValue={(val: types.assetSelector.AssetSelectorValueObject) => {
                setParams({
                  ...params,
                  asset_fids: val as string[],
                });
              }}
              createId={(a) => `${a.fid}`}
              disabled={readOnly || allAssets}
              dates={dates}
              fields={[
                { title: 'Ticker', key: 'ticker' },
                { title: 'Name', key: 'name' },
                { title: 'Country', key: 'quotation_country' },
              ]}
              tableView={true}
              required={false}
              fieldLabel="Select Specific Assets"
              multiple
              errorState={validationDef?.fields?.includes(`asset_${id}`)}
            />
          </mui.core.Grid>
        )}
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default SharesOutstandingConstraint;
